import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

import BaseIcon from '../../../IconV1'

export const Icon = styled(BaseIcon).attrs({
  size: '15',
})`
  fill: ${color.AQUAMARINE};
  margin-bottom: 0.125rem;
`

export const Info = styled.div`
  margin-left: 1.875rem;

  ${p =>
    p.hasValues &&
    `
    text-align: right;
  `}

  ${p =>
    p.forDates &&
    `
    margin-left: 0;
  `}

  & p {
    color: ${color.GREY};
    font-size: 0.75rem;
    line-height: 1.25rem;
    margin-bottom: 0;
  }
`

export const RollUp = styled.div`
  display: flex;
  flex-direction: column;
`

export const Row = styled.div`
  display: flex;
  flex-direction: column;
`

export const SubRow = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Toggle = styled.div`
  display: flex;
  align-items: end;
  cursor: pointer;

  & div {
    color: ${({ busy, theme = {} }) =>
      busy ? color.MORTAR : color.AQUAMARINE};
    font-size: 0.875rem;
    line-height: 1.25rem;
    margin-left: 0.625rem;
  }
`
